import superagent from 'superagent'

export const filterCreate = filter => {
  return {
    type: 'FILTER_CREATE',
    payload: filter
  }
}

export const filterClear = () => ({
  type: 'FILTER_CLEAR'
})

export const filterUpdate = filter => ({
  type: 'FILTER_UPDATE',
  payload: filter
})

export const filterDelete = id => ({
  type: 'FILTER_DELETE',
  payload: id
})

export const addActiveFilter = (id, filter) => (dispatch, getState) => {
  const filter = getState().filters[id],
    active = [].concat(filter.activeFilters)
  active.push(filter)
  filter.active = active
  dispatch(filterUpdate, filter)
}

export const removeActiveFilter = (id) => {
  return null
}

export const fetchHuntingUnit_GetLandUse = (layerId, unitName) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/HuntingUnit/GetLandUse?layerId=${layerId}&UnitName=${unitName}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          // reject(err)
          resolve()
          return
        } else {
          resolve(res.body)
        }
      })
  })
}

export const fetchFilterHuntModel_Get = (layerId, reqStr) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/FilterHuntModel/Get/${layerId}?${reqStr}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          // reject(err)
          resolve()
          return
        } else {
          console.log('hunt model', res)
          resolve(res.body)
        }
      })
  })
}

export const fetchFilterHuntModel_GetHuntData = (id, reqStr, unitId) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/FilterHuntModel/GetHuntData/${id}?${reqStr}&unitId=${unitId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          resolve()
        } else {
          resolve(res.body)
        }
      })
  })
}

export const fetchFiltering = (speciesId, mapId, bounds) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(
        speciesId
          ? `${__API_URI__}/FilterHuntModel/Get/${mapId}`
          : `${__API_URI__}/FilterModel/Get/${mapId}?bbox=${bounds.west},${bounds.south},${bounds.east},${bounds.north}`
      )
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          const filterObj = Object.assign({ id: mapId, activeFilters: [] }, res.body)
          dispatch(filterCreate(filterObj))
          resolve(res.body)
        }
      })
  })
}
